import * as requestTwo from '@ge/shared/services/api';

const CMN_BASE_URL = process.env.REACT_APP_DIGITAL_WIND_FARM_CMN_API;

export const getRocStations = () => requestTwo.get('/cmn/rock-stations', { baseURL: CMN_BASE_URL });
